export default __webpack_public_path__ + "static/media/debt-collections.7c606930.jpg";